import React from "react";
import { FileText, Download } from "lucide-react";

export function MediaGallery({ images = [], title = "Gallery" }) {
  if (!images.length) return null;
  return (
    <div data-testid="media-gallery">
      <h3 className="heading-md mb-5">{title}</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {images.map((src, i) => (
          <a key={i} href={src} target="_blank" rel="noreferrer" className="block overflow-hidden rounded-lg border border-gray-200 group">
            <img
              src={src}
              alt={`${title} ${i + 1}`}
              className="w-full h-40 sm:h-48 object-cover transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
          </a>
        ))}
      </div>
    </div>
  );
}

export function DocumentList({ documents = [], title = "Downloads" }) {
  if (!documents.length) return null;
  return (
    <div data-testid="document-list">
      <h3 className="heading-md mb-5">{title}</h3>
      <ul className="space-y-3">
        {documents.map((doc, i) => (
          <li key={i}>
            <a
              href={doc.file_url || "#"}
              download
              className="flex items-center gap-3 card-bcs px-5 py-3.5 text-sm font-medium text-ink hover:text-maroon"
            >
              <FileText size={18} className="text-maroon shrink-0" />
              <span className="flex-1">{doc.title}</span>
              <Download size={16} className="text-ink-muted" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
